let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("3a4K1")).then(() => parcelRequire('1oHUa'));